module.exports = __webpack_public_path__ + "static/favicon-74bcb0f87984735ab18658128fe6595d.png";